import { IconButton, makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Close } from '@material-ui/icons';
import { colors } from 'theme';
import ClosureWarningIcon from './Icons/ClosureWarningIcon';

const HIDE_BROWSER_POPUP_KEY = 'hideUserPopup';

const useStyles = makeStyles(() => ({
  hidden: {
    display: 'none',
  },
  popup: {
    width: '692px',
    height: '45px',
    fontSize: '12px',
    lineHeight: '16px',
    background: '#F4F4F4',
    boxShadow: '0px 4px 25px rgba(0,0,0,0.25)',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    color: colors.neutral800,
    textAlign: 'center',
    fontWeight: 600,
  },
  popupContainer: {
    position: 'fixed',
    bottom: '50px',
    width: '100vw',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    zIndex: 999,
  },
  warningIcon: {
    margin: '0px 13px 0px 18px',
  },
  closeIcon: {
    marginLeft: '12px',
    width: 12,
    height: 12,
  },
}));

const BrowserSupport: React.FC<{}> = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [isHidden, setHidden] = useState<boolean>(true);

  const saveBrowserPopupParameter = useCallback(() => {
    setHidden(true);
    localStorage.setItem(HIDE_BROWSER_POPUP_KEY, 'true');
  }, [setHidden]);

  useEffect(() => {
    if (/Chrome/.test(navigator.userAgent)) {
      localStorage.setItem(HIDE_BROWSER_POPUP_KEY, 'true');
      return;
    }
    if (localStorage.getItem(HIDE_BROWSER_POPUP_KEY) !== 'true') {
      setHidden(false);
    }
  }, [setHidden]);

  return (
    <>
      <div
        className={classNames({
          [classes.hidden]: isHidden,
          [classes.popupContainer]: !isHidden,
        })}
      >
        <div className={classes.popup}>
          <ClosureWarningIcon width={24} height={24} className={classes.warningIcon} />
          {t('unsupportedBrowser')}
          <IconButton aria-label="close" className={classes.closeIcon} onClick={saveBrowserPopupParameter}>
            <Close />
          </IconButton>
        </div>
      </div>
    </>
  );
};

export default BrowserSupport;
